<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size: 30px; color:black;" class="mb-0">Requerimientos</p>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
            <v-btn @click="activaregistro">Registro</v-btn>
            <v-btn @click="activaadministracion">Listado</v-btn>
        </v-btn-toggle>
      </v-col>
      <!-- Registro-->
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <v-autocomplete
                v-model="requerimientoid"
                :items="listarequerimientos"
                :search-input.sync="searchrequerimiento"
                flat
                prepend-inner-icon="mdi-magnify"
                outlined dense hide-details
                hide-no-data
                hide-details
                label="Buscar requerimiento..."
                solo-inverted
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" class="pt-5" dense>
              <v-alert
                v-if="mensaje"
                :type="tipoMensaje"
                dense
                outlined
              >
                {{ mensaje }}
              </v-alert>
              <span class="font-weight-bold primary--text"
                >1. UNIDAD MINERA TÍA MARÍA</span>
              <v-row dense>
                <v-col cols="12">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="pr-0">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6">
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-select
                            :items="lista_areas"
                            item-value="id"
                            item-text="nombre_area"
                            v-model="id_areausuaria"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-format-list-bulleted"
                            class="pt-0"
                            label="Área Usuaria Responsable del Contrato"
                            ref="id_areausuaria"
                            :rules="[v => !!v || 'El área usuaria es obligatoria']"
                            required
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <!-- <v-autocomplete
                            v-model="idoperador"
                            :items="empleadosFiltrados"
                            label="Operador de Contrato"
                            class="pt-0"
                            dense
                            :rules="[() => !!idoperador || 'Campo requerido']"
                            :error-messages="errorMessages"
                            ref="idoperador"
                            required
                          ></v-autocomplete> -->
                          <v-select
                            v-model="idoperador"
                            :items="empleadosFiltrados"
                            item-text="text"
                            item-value="value"
                            label="Operador de Contrato"
                            class="pt-0"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-account-tie"
                            :rules="[v => !!v || 'Campo requerido']"
                            :error-messages="errorMessages"
                            ref="idoperador"
                            required
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-text-field
                            v-model="codigo_contrato"
                            label="Código de Contrato"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-file-document-outline"
                            class="pt-0"
                            :rules="[
                              () => !!codigo_contrato || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="codigo_contrato"
                            required
                          ></v-text-field>
                        </v-col>
                        <span class="font-weight-bold primary--text">2. CONTRATISTA SOLICITANTE</span>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-select
                            :items="lista_contratistas"
                            item-value="id_empresa_contratista"
                            item-text="empresa_contratista"
                            v-model="id_contratista"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-domain"
                            class="pt-0"
                            label="Empresa Contratista"
                            ref="id_contratista"
                            required
                            :disabled="id_contratista != null && !esAdmin"
                          ></v-select>
                        </v-col>
                        <!-- <v-col
                          v-if="esAdmin"
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12"
                          xl="12"
                          dense
                        >

                          <v-autocomplete
                            v-model="empresasAdjudicadas"
                            :items="empresasLis"
                            label="Empresas Adjudicadas"
                            class="pt-0"
                            dense
                            multiple
                            chips
                            clearable
                            deletable-chips
                            ref="empresasAdjudicadas"
                          ></v-autocomplete>

                        </v-col> -->
                        <v-row dense>
                          <v-col cols="8" md="8" sm="12" xs="12" dense>
                            <span class="font-weight-bold primary--text">3. DETALLES DE LA SOLICITUD DE SERVICIO</span>
                          </v-col>
                          <v-col
                            cols="4"
                            md="4"
                            sm="12"
                            xs="12"
                            dense
                            class="d-flex justify-end"
                          >
                            <v-btn
                              class="ma-2"
                              small
                              outlined
                              fab
                              color="primary"
                              @click.stop="abrirDialogDetalle"
                              :disabled="nuevodetalle"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                            <v-dialog v-model="dialogdetalle" max-width="400px">
                              <v-card outlined class="pa-2">
                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    xs="12"
                                    dense
                                    class="pt-0 d-flex justify-center"
                                  >
                                    <span class="font-weight-bold mb-2 justify-center"
                                      >Detalles</span
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-card-text dense class="mt-4">
                                  <v-row dense>
                                    <v-col
                                      cols="12"
                                      md="12"
                                      sm="12"
                                      xs="12"
                                      dense
                                      class="pt-0"
                                    >
                                      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                                        <v-text-field
                                          v-model="cantidad"
                                          label="Cantidad"
                                          outlined dense hide-details
                                          prepend-inner-icon="mdi-counter"
                                          class="pt-0"
                                          :rules="[
                                            () => !!cantidad || 'Campo requerido',
                                          ]"
                                          :error-messages="errorMessages"
                                          ref="cantidad"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                                        <v-text-field
                                          v-model="servicio"
                                          label="Servicio"
                                          outlined dense hide-details
                                          prepend-inner-icon="mdi-briefcase"
                                          class="pt-0"
                                          :rules="[
                                            () => !!servicio || 'Campo requerido',
                                          ]"
                                          :error-messages="errorMessages"
                                          ref="servicio"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                                        <v-text-field
                                          v-model="detalle"
                                          label="Detalle"
                                          outlined dense hide-details
                                          prepend-inner-icon="mdi-text-box-outline"
                                          class="pt-0"
                                          :rules="[
                                            () => !!detalle || 'Campo requerido',
                                          ]"
                                          :error-messages="errorMessages"
                                          ref="detalle"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    xs="12"
                                    dense
                                    class="pt-0 d-flex justify-center"
                                  >
                                    <v-btn
                                      class="ma-2"
                                      color="primary"
                                      :disabled="overlay2"
                                      @click="agregarDetalle"
                                      >Guardar</v-btn
                                    >
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-dialog>
                          </v-col>
                          <v-col cols="12" md="12" sm="12" xs="12" dense>
                            <v-data-table
                              :headers="headerdetalles"
                              :items="lista_detalles"
                              hide-default-footer
                              :items-per-page="-1"
                              class="elevation-1"
                              dense
                            >
                              <template v-slot:item.actions="{ item }">
                                <v-icon
                                  color="primary"
                                  class="pr-1"
                                  @click="editItemDetalle(item)"
                                  >mdi-square-edit-outline</v-icon
                                >
                                <v-icon @click="deleteItemDetalle(item)" color="primary"
                                  >mdi-delete</v-icon
                                >
                              </template> -->
                              <template v-slot:item.resumen="{ item }">
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title>{{item.denominacion}}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                              <span>{{ lista_detalles.length }}</span>
                              <template v-slot:no-data
                                >No tiene registrada información sobre los detalles.</template
                              >
                              <template v-slot:no-results>NO RESULTS HERE!</template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-col>
                    <v-divider class="mx-1" vertical></v-divider>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5">
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-text-field
                            v-model="requerimientofecha_convocatoria"
                            label="Fecha de inicio del servicio"
                            class="pt-0"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-calendar-start"
                            type="date"
                            max-width="43"
                            :rules="[
                              () =>
                                !!requerimientofecha_convocatoria ||
                                'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="requerimientofecha_convocatoria"
                            required
                            @change="generarFechaInicio1"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-text-field
                            v-model="tiempo_contratacion"
                            label="Tiempo de contratación (días)"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-timer"
                            class="pt-0"
                            :rules="[
                              () => !!tiempo_contratacion || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="tiempo_contratacion"
                            type="number"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                           <v-select
                            :items="rubro_tipo_s"
                            item-value="id"
                            item-text="nombrecategoria"
                            v-model="rubro_tipo_servicio"
                            label="Rubro (Tipo de Servicio)"
                            class="pt-0"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-briefcase"
                            :rules="[() => !!rubro_tipo_servicio || 'Campo requerido']"
                            :error-messages="errorMessages"
                            ref="rubro_tipo_servicio"
                            required
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12"
                          xl="12"
                          dense
                        >
                          <v-file-input
                            v-model="archivoReq"
                            label="Adjuntar archivo"
                            outlined
                            dense
                            hide-details
                            prepend-inner-icon="mdi-paperclip"
                            prepend-icon=""
                            show-size
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                            clearable
                          ></v-file-input>
                          <div
                            v-if="nombreArchivoReq"
                            class="mt-2"
                          >
                            <v-icon small color="primary">
                              mdi-file-document-outline
                            </v-icon>

                            <span class="ml-1">
                              Archivo actual: <strong>{{ nombreArchivoReq }}</strong>
                            </span>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-textarea
                            label="Observaciones"
                            v-model="observaciones"
                            class="pt-0"
                            :rules="[
                              () =>
                                !!observaciones || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="observaciones"
                            required
                            outlined dense hide-details
                            prepend-inner-icon="mdi-note-text-outline"
                          ></v-textarea>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-text-field
                            v-model="elaborado_por"
                            label="Elaborado por:"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-account-check"
                            class="pt-0"
                            :rules="[
                              () => !!elaborado_por || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="elaborado_por"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                          class="pt-0"
                        >
                          <v-text-field
                            v-model="cargo_area"
                            label="Cargo / Área:"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-badge-account"
                            class="pt-0"
                            :rules="[
                              () => !!cargo_area || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="cargo_area"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-text-field
                            v-model="empresa_contacto"
                            label="Empresa:"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-domain"
                            class="pt-0"
                            :rules="[
                              () => !!empresa_contacto || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="empresa_contacto"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-textarea
                            v-model="celular_contacto"
                            label="Celular Contacto:"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-phone"
                            :rows="1"
                            class="pt-0"
                            :rules="[
                              () => !!celular_contacto || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="celular_contacto"
                            required
                          ></v-textarea>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <!-- <v-text-field
                            v-model="fecha_solicitud"
                            label="Fecha Solicitud:"
                            dense
                            class="pt-0"
                            :rules="[
                              () => !!fecha_solicitud || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="fecha_solicitud"
                            required
                          ></v-text-field> -->
                          <v-text-field
                            v-model="fecha_solicitud"
                            label="Fecha Solicitud:"
                            class="pt-0"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-calendar"
                            type="date"
                            max-width="43"
                            :rules="[
                              () =>
                                !!fecha_solicitud ||
                                'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="fecha_solicitud"
                            required
                            @change="generarFechaInicio2"
                            :disabled="!editando_fec_sol"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12" xl="12"
                          dense
                        >
                          <v-text-field
                            v-model="correo"
                            label="Correo:"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-email-outline"
                            class="pt-0"
                            :rules="[
                              () => !!correo || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="correo"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="12"
                          sm="12"
                          xs="12"
                          lg="12"
                          xl="12"
                        >
                          <v-select
                            v-model="tiempo_publicacion"
                            :items="[2, 3, 4, 5]"
                            label="Tiempo de publicación"
                            suffix="días"
                            outlined dense hide-details
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    class="mb-5"
                    @click="saveRequerimiento"
                    :disabled="overlayr"
                    :loading="overlayr"
                    >Guardar</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Administracion -->
      <v-col cols="12" md="12" sm="12" xs="12" dense v-if="administracion">
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="requerimiento_headers"
                :items="requerimiento_items"
                :search="searchrequerimiento2"
                sort-by="denominacion"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2" style="color:white;"
                      >Requerimientos</v-toolbar-title
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchrequerimiento2"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.denominacion="{ item }">
                  <div
                    style="
                      width:500px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.denominacion }}
                  </div>
                </template>
                <template v-slot:item.detalles="{ item }">
                  {{ item.detalles.map(d => d.servicio).join(', ') }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemRequerimiento2(item)"
                    >mdi-square-edit-outline</v-icon
                  >
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Alertas -->
      <v-col cols="12" md="12" sm="12" xs="12" dense v-if="alertas">
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="requerimientoalerta_headers"
                :items="requerimientoalerta_items"
                :search="searchrequerimientoalerta"
                sort-by="denominacion"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2"
                      >Alertas - Requerimientos</v-toolbar-title
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchrequerimientoalerta"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.estadolocales="{ item }">
                  <v-chip
                    class="ma-2"
                    x-small
                    dark
                    :color="getcolorestado(item.fecha_finlocales)">
                    {{ item.estadolocales }}
                  </v-chip>
                </template>
                <template v-slot:item.estadoactores="{ item }">
                  <v-chip
                    class="ma-2"
                    x-small
                    dark
                    :color="getcolorestado(item.fecha_finactores)">
                    {{ item.estadoactores }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemRequerimiento2(item)"
                    >mdi-square-edit-outline</v-icon
                  >
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{ icon }}</v-icon>
        {{ error }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
//funciones de los filtros
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import FilenameOption from '../views/excel/components/FilenameOption'
import AutoWidthOption from '../views/excel/components/AutoWidthOption'
import BookTypeOption from '../views/excel/components/BookTypeOption'
import { parseTime } from '../utils'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
//Nuestro codigo Vue
export default {
  data: () => ({
    nuevo: true,
    nuevodetalle: false,
    registro: true,
    filtros: false,
    administracion: false,
    formatos: false,
    alertas: false,
    searchInput: null,
    rubro_tipo_servicio: "",
    rubro_tipo_s: [],
    rubro_tipo_s_f: [],
    id_areausuaria: "",
    cobertura: [],
    participacion_ccia: [],
    codigo_contrato: "",
    lista_detalles: [],
    lista_areas: [],
    contratosempresas: [],
    selectedRows: [],
    editedIndexDetalle: -1,
    requerimientofecha_convocatoria: "",
    loading: false,
    chkempresas: false,
    empresasSeleccionadas: [],
    lista_empresas: [], // viene de la API
    searchInputEmpresas: null,
    lista_contratistas: [],
    id_contratista: "",
    headerdetalles: [
      { text: "Cantidad", value: "cantidad", align: "start" },
      { text: "Servicio", value: "servicio", align: "start" },
      { text: "Detalle", value: "detalle", align: "start" },
      { text: "Opciones", value: "actions", sortable: false, align: "end" },
    ],
    headercontratosempresas: [
      { text: "Empresa", value: "razonsocial", align: "start", width: "150px" },
      { text: "RUC", value: "ruc", align: "center" },
      { text: "Correo", value: "correo", align: "center" },
      { text: "Tipo de Servicio", value: "NombreCategoria", align: "center" },
      { text: "Carta de presentación", value: "carta_presentacion", align: "center" },
      { text: "Diagnóstico CCIA", value: "diagnostico_ccia", align: "center" },
      { text: "Resultado final de localía", value: "resultado_final_localia", align: "start" },
      { text: "Puntaje total de localía", value: "puntaje_total_localia", align: "start" },
      { text: "Comentario", value: "comentario", align: "start" },
      { text: "Categoría Proveedor", value: "categoria_proveedor", align: "center" },
    ],
    requerimiento_headers: [
      { text: "Código de requerimiento", align: "start", value: "denominacion", width: "180px"},
      { text: "Fecha de solicitud", value: "fecha_solicitud" },
      { text: "Vigencia", value: "tiempo_contratacion" },
      { text: "Fecha de envío de propuesta", value: "fecha_inicio" },
      { text: "Contratista", value: "empresa_contratista" },
      { text: "Rubro", value: "rubro_tipo_servicio" },
      { text: "Detalles", value: "detalles" },
      { text: "Opciones", value: "actions", sortable: false },
    ],
    chktiposervicio: false,
    chktipolocacion: false,
    chkccategorizacion: false,
    chktrabajando: false,
    chkfechas: false,
    chkmonto: false,
    chkrubroempresa: false,
    chkcobertura: false,
    chkcccia: false,
    requerimiento_items: [],
    searchrequerimiento: "",
    tipos_servicio: [],
    search: "",
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    overlay2: false,
    overlayr: false,
    model: [],
    snackbar: false,
    error: null,
    errorMessages: "",
    form1HasErrors: false,
    form2HasErrors: false,
    form3HasErrors: false,
    form4HasErrors: false,
    form5HasErrors: false,
    color: "#2A3B4D",
    icon: "mdi-thumb-up",
    dialogeducacion: false,
    dialogdetalle: false,
    dialogexperiencia: false,
    dialogconocimiento: false,
    menu2: false,
    menu3: false,
    /*Area y Empresa*/
    areas: [],
    empleados: [],
    empleadosFiltrados: [], 
    idempresa: "",
    idoperador: "",
    searchareas: "",
    empresa: "",
    listarequerimientos: [],
    listarequerimientos2: [],
    requerimientos: [],

    /* Requerimiento */
    searchrequerimiento2: "",
    editedIndexrequerimiento: -1,
    requerimientoid: "",
    requerimientoid2: "",
    //requerimientodenominacion: "",
    requerimiento_tipo: "",
    empresa_contratista: "",
    ruc_contratista: "",
    representante_contratista: "",
    celular_contratista: "",
    representante_sitio_contratista: "",
    celular_sitio_contratista: "",
    tiempo_contratacion: "",
    observaciones: "",
    elaborado_por: "",
    cargo_area: "",
    empresa_contacto: "",
    celular_contacto: "",
    editando_fec_sol: false,
    fecha_solicitud: new Date().toISOString().slice(0, 10),
    correo: "",
    cantidad: "",
    servicio: "",
    detalle: "",
    categorizacion_proveedor: [],
    categorizacion: [
      { text: "Categoría A: Proveedor Local Estratégico", value: "Categoría A: Proveedor Local Estratégico"},
      { text: "Categoría B: Proveedor Local Genuino", value: "Categoría B: Proveedor Local Genuino"},
      { text: "Categoría C: Proveedor Local en Desarrollo", value: "Categoría C: Proveedor Local en Desarrollo"},
      { text: "Categoría D: Proveedor Consorciado con Componente Local", value: "Categoría D: Proveedor Consorciado con Componente Local"},
      { text: "Categoría E: Proveedor Regional Registrado", value: "Categoría E: Proveedor Regional Registrado"},
      { text: "Categoría F: Proveedor Foráneo No Aplicable", value: "Categoría F: Proveedor Foráneo No Aplicable"},
    ],
    lista_cobertura: [
        { tipo: "Transporte", value: 1 },
        { tipo: "Maquinaria", value: 2 },
        { tipo: "Combustible", value: 8 },
        { tipo: "Alojamiento", value: 10 },
        { tipo: "Alimentacion", value: 11 },
    ],
    cocinaplanta: {
        direccioncocinaplanta: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        servicioraciones: false,
        serviciobuffet: false,
        serviciocafeteria: false,
        serviciocatering: false,
        capacidaddiaria: null,
        certificadosanitariovigente: false,
        vehiculosrefrigerados: false,
        capacidadinstalarcomedor: false,
        propuestaeconomica: null
      },

      hospedaje: {
        habitacionesindividuales: null,
        habitacionesdobles: null,
        habitacionesmultiples: null,
        capacidadtotalcamas: null,
        serviciodesayuno: false,
        serviciowifi: false,
        serviciolavanderia: false,
        servicioestacionamiento: false,
        servicioaguacaliente: false,
        certificadoitsevigente: false,
        tarifacorporativareferencial: null
      },

      garaje: {
        direcciongarajebase: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        fecharegistro: new Date().toISOString().slice(0, 10)
      },

      flota: {
        tipounidad: '',
        placa: '',
        marca: '',
        modelo: '',
        anio: null,
        capacidad: '',
        soatpolizavigente: false,
        gps: false,
        cinturon3puntos: false,
        tarifareferencial: null
      },

      lista_flota: [],

      headerFlota: [
        { text: 'tipo', value: 'tipounidad' },
        { text: 'placa', value: 'placa' },
        { text: 'marca', value: 'marca' },
        { text: 'año', value: 'anio' },
        { text: 'acciones', value: 'actions', sortable: false }
      ],
      indexFlotaEdit: null,

      ubicacionequipo: {
        ubicacionequipogaraje: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: ''
      },

      maquinaria: {
        tipomaquinaria: '',
        marcamodelo: '',
        anio: null,
        capacidadtecnica: '',
        certificadosvigentes: false,
        incluyeoperador: false,
        incluyecombustible: false,
        tipotarifa: '',
        tarifareferencial: null
      },

      lista_maquinaria: [],

      headerMaquinaria: [
        { text: 'tipo', value: 'tipo' },
        { text: 'marca / modelo', value: 'marca_modelo' },
        { text: 'año', value: 'anio' },
        { text: 'capacidad', value: 'capacidad_tecnica' },
        { text: 'acciones', value: 'actions', sortable: false }
      ],

      indexMaquinariaEdit: null,

      plantagrifo: {
        direccionplantagrifo: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        combustibledieselb5: false,
        combustiblegasolina90: false,
        combustiblegasolina95: false,
        combustibleglp: false,
        capacidadsuministrodiario: null,
        capacidadcisternas: null,
        permisososinergminvigentes: false,
        tiempominimopreaviso: null,
        tarifareferencial: null
      },
    coberturasSeleccionadas: [], // Aquí guardamos lo que el usuario seleccione
    dialogFiltros: false,
    l_participacion_ccia: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
    requerimiento_estado: "",
    requerimiento_estados: [
      { text: "Planificado", value: "PLANIFICADO" },
      { text: "Aprobado", value: "APROBADO" },
      { text: "Iniciado", value: "INICIADO" },
      { text: "En proceso", value: "EN PROCESO" },
      { text: "Cerrado", value: "CERRADO" },
      { text: "Liberado", value: "LIBERADO" },
    ],
    observaciones: "",
    chkCarta: false,
    filtroCarta: "",

    /*Soporte*/
    valida: 0,
    validamensaje: [],
    mensaje: "",
    tipoMensaje: "",
    esAdmin: false,
    empresasAdjudicadas: [],
    empresasLis: [],
    archivoReq: null,
    nombreArchivoReq: null,
    tiempo_publicacion: 5,
  }),

  created() {
    this.idusuario = localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.empresaid = localStorage.getItem('empresa')
    this.empresaid = this.empresaid ? Number(this.empresaid) : null
    this.id_contratista = localStorage.getItem('empresacontratista')
    this.id_contratista = this.idcontratista ? Number(this.idcontratista) : null
    this.esAdmin =
    this.rol === 'ADMINISTRADOR'
    let me = this;
    me.listar();
    me.selectEmpleados();
    me.listarRequerimiento();
    me.selectRequerimiento();
    this.cargarCategorias();
    this.cargarAreasUsuaria();
    this.cargarEmpresasContratistas();
    // this.selectEmpresa();
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },
  computed: {
    form1() {
      return {
        // idempresa: this.idempresa,
        observaciones: this.observaciones,
        idoperador: this.idoperador,
        codigo_contrato: this.codigo_contrato,
        tiempo_contratacion: Number(this.tiempo_contratacion),
        elaborado_por: this.elaborado_por,
        cargo_area: this.cargo_area,
        empresa_contacto: this.empresa_contacto,
        celular_contacto: this.celular_contacto,
        fecha_solicitud: this.fecha_solicitud,
        correo: this.correo,
        rubro_tipo_servicio: this.rubro_tipo_servicio,
        id_areausuaria: this.id_areausuaria,
        requerimientofecha_convocatoria: this.requerimientofecha_convocatoria,
      };
    },
    form2() {
      return {
        educaciondenominacion: this.educaciondenominacion,
      };
    },
    form3() {
      return {
        experienciapuesto: this.experienciapuesto,
      };
    },
    form4() {
      return {
        conocimientodenominacion: this.conocimientodenominacion,
      };
    },
  },
  methods: {
    crearJSONfinal(data){
      // console.log("Entra a crear el JSON final");
      // console.log(JSON.stringify(data));
      let me = this;
      let datafinal=[];
      //var ajson=JSON.stringify(json);
      data.forEach((item, index)=>{
      let obj;
      obj={
        denominacion:item.denominacion,
        fecha_convocatoria:item.fecha_convocatoria,
        fecha_iniciolocales:item.fecha_iniciolocales,
        fecha_finlocales:item.fecha_finlocales,
        fecha_inicioactores:item.fecha_inicioactores,
        fecha_finactores:item.fecha_finactores,
        estadolocales:me.getestado(item.fecha_finlocales),
        estadoactores:me.getestado(item.fecha_finactores)
      }
      datafinal.push(obj)
    });
    // console.log(JSON.stringify(datafinal));
    return datafinal;
    },
    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.rubro_tipo_s = response.data;
        this.rubro_tipo_s_f = response.data;
        // console.log(this.rubro_tipo_s)
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    limpiarDetalle() {

      this.editIndex = -1;

      this.cantidad = null;
      this.servicio = null;
      this.detalle = null;

      this.errorMessages = [];

      // reset visual validations
      this.$nextTick(() => {

        if (this.$refs.cantidad) {
          this.$refs.cantidad.resetValidation();
        }

        if (this.$refs.servicio) {
          this.$refs.servicio.resetValidation();
        }

        if (this.$refs.detalle) {
          this.$refs.detalle.resetValidation();
        }

      });
    },
    agregarDetalle() {
      const nuevo = {
        cantidad: this.cantidad,
        servicio: this.servicio,
        detalle: this.detalle
      };

      // MODO EDITAR
      if (this.editIndex > -1) {
        Object.assign(this.lista_detalles[this.editIndex], nuevo);
      } 
      // MODO AGREGAR
      else {
        this.lista_detalles.push(nuevo);
      }
      // this.lista_detalles.push({
      //   cantidad: this.cantidad,
      //   detalle: this.detalle
      // });
      this.dialogdetalle = false;
      this.limpiarDetalle();
      // console.log(this.lista_detalles);
    },
    getestado(fechafin) {
      let respuesta = "";
      let hoy = new Date();
      //console.log("Entra a generar estado locales");
      if (this.isDate(fechafin)) {
        let fecha = new Date(fechafin + "T00:00:00");
        //console.log(this.mostrarFecha(hoy)+"-"+this.mostrarFecha(fecha))     
        if(this.mostrarFecha(hoy)==this.mostrarFecha(fecha))
        {
          respuesta="Urgente (0 días)";
        }
        else{
          if(Math.round(fecha - hoy) < 0){
            respuesta="No monitoreado";
          }
          else{
            let Difference_In_Time = Math.abs(fecha - hoy); 
            let Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24)); 
            if(Difference_In_Days== 1){
              respuesta="Urgente (1 día)";
            }
            if(Difference_In_Days== 2 ){
              respuesta="Alerta (2 días)";
            }
             if(Difference_In_Days== 3){
              respuesta="Alerta (3 días)";
            }
            if(Difference_In_Days>=4){
              respuesta="A tiempo (+ 4 días)"
            }
          //console.log("Diferencia "+Difference_In_Days);
          //respuesta = Math.round(Difference_In_Days);
          }
        }
      }
      return respuesta;
    },
    saveDetalle() {
      let me = this;
      // me.validar2();
      if (me.form2HasErrors == false) {
        // me.saveEducacionMatch();
        for (const item of me.lista_detalles) {
          if (me.editedIndexDetalle > -1) {
              let me = this;
              axios
                .put("/api/Detalles/Actualizar", {
                  iddetalles: item.iddetalles,
                  cantidad: Number(item.cantidad),
                  servicio: item.servicio,
                  detalle: item.detalle,
                  idrequerimiento: me.requerimientoid,
                })
                .then(function (response) {
                  me.color = "#2A3B4D";
                  me.icon = "mdi-thumb-up";
                  me.error = "Registro exitoso";
                  me.snackbar = true;
                })
                .catch(function (error) {
                  console.log(error.response);
                  if (error.response.status == 400) {
                    me.error = error.response.data.toString();
                  }
                  me.color = "#E53935";
                  me.icon = "mdi-alert";
                  me.overlay2 = false;
                  me.snackbar = true;
                });
            } else {
              let me = this;
              axios
                .post("/api/Detalles/Crear", {
                  cantidad: Number(item.cantidad),
                  servicio: item.servicio,
                  detalle: item.detalle,
                  idrequerimiento: me.requerimientoid,
                })
                .then(function (response) {
                  me.color = "#2A3B4D";
                  me.icon = "mdi-thumb-up";
                  me.error = "Registro exitoso";
                  me.snackbar = true;
                })
                .catch(function (error) {
                  console.log(error.response);
                  if (error.response.status == 400) {
                    me.error = error.response.data.toString();
                  }
                  me.color = "#E53935";
                  me.icon = "mdi-alert";
                  me.overlay2 = false;
                  me.snackbar = true;
                });
            }
          }
      }
    },

    editItemDetalle(item) {
      this.dialogdetalle = true;
      this.editIndex = this.lista_detalles.indexOf(item);
      this.cantidad = item.cantidad;
      this.servicio = item.servicio;
      this.detalle = item.detalle;
      this.editedIndexDetalle = 1;
    },
    deleteItemDetalle(item) {
      const index = this.lista_detalles.indexOf(item);
      if (index > -1) {
        this.lista_detalles.splice(index, 1);
      }
      let me = this;
      me.detalleid = item.detalleid;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/Detalles/Eliminar/" + me.detalleid)
          .then(function (response) {
            //me.snackbar = true;
            me.editedIndexEducacion = -1;
            //me.e6 = 2;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;

            me.listarDetalle();
          })
          .catch(function (error) {
            console.log(error.response);
          });
    },
    isDate(value) {
      switch (typeof value) {
        case "number":
          return true;
        case "string":
          return !isNaN(Date.parse(value));
        case "object":
          if (value instanceof Date) {
            return !isNaN(value.getTime());
          }
        default:
          return false;
      }
    },
    activaregistro() {
      this.registro = true;
      this.administracion = false;
      this.formatos = false;
      this.alertas = false;
    },
    activaadministracion() {
      this.registro = false;
      this.administracion = true;
      this.formatos = false;
      this.alertas = false;
    },
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) {
          this.form1HasErrors = true;
          this.$refs[f]?.focus();
        }

        const ref = this.$refs[f];

        if (ref && typeof ref.validate === "function") {
          ref.validate(true);
        } else {
          console.warn(`El ref '${f}' no existe o no tiene validate()`);
        }
      });
      if (this.form1HasErrors) {
        this.mensaje = "Debe completar los campos obligatorios";
        this.tipoMensaje = "error";
      }
    },
    validar2() {
      /*Validacion Forms */
      this.error = null;
      this.form2HasErrors = false;

      Object.keys(this.form2).forEach((f) => {
        if (!this.form2[f]) this.form2HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.requerimientoid == null || this.requerimientoid == "") {
        this.error = "Debe selecionar un requerimiento previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form2HasErrors = true;
      }
    },
    validar3() {
      /*Validacion Forms */
      this.error = null;
      this.form3HasErrors = false;

      Object.keys(this.form3).forEach((f) => {
        if (!this.form3[f]) this.form3HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.requerimientoid == null || this.requerimientoid == "") {
        this.error = "Debe selecionar un requerimiento previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form3HasErrors = true;
      }
    },
    validar4() {
      /*Validacion Forms */
      this.error = null;
      this.form4HasErrors = false;

      Object.keys(this.form4).forEach((f) => {
        if (!this.form4[f]) this.form4HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.requerimientoid == null || this.requerimientoid == "") {
        this.error = "Debe selecionar un requerimiento previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form4HasErrors = true;
      }
    },
    editItemRequerimiento2(item) {
      this.overlay = true;
      this.requerimientoid = item.idrequerimiento;
      this.registro = true;
      this.administracion = false;
      this.editItem();
      this.overlay = false;
    },
    remove(item) {
      const index = this.categorizacion_proveedor.indexOf(item.value);
      if (index !== -1) {
        this.categorizacion_proveedor.splice(index, 1);
      }
    },
    remove2(item) {
      const index = this.participacion_ccia.indexOf(item.value);
      if (index !== -1) {
        this.participacion_ccia.splice(index, 1);
      }
    },
    remove5(item) {
      const index = this.cobertura.indexOf(item.value);
      if (index !== -1) {
        this.cobertura.splice(index, 1);
      }
    },
    abrirDialogDetalle() {
      this.dialogdetalle = true;
      this.limpiarDetalle();
    },
    listar() {
      let me = this;
      me.requerimiento_items=[];
      me.requerimientoalerta_items=[];
      axios
        .get(`api/Requerimientos/Listar?idusuario=${me.idusuario}`)
        .then(function (response) {
          me.requerimiento_items = response.data;
          // console.log(me.requerimiento_items);
          me.requerimientoalerta_items = me.crearJSONfinal(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      let me = this;
      me.requerimientoid = "";
      me.observaciones = "";
      // me.id_areausuaria = "";
      // me.idoperador = "";
      // me.codigo_contrato = "";
      // me.empresa_contratista = "";
      // me.id_contratista = "";
      me.tiempo_contratacion =  "";
      // me.elaborado_por =  "";
      // me.cargo_area = "";
      // me.empresa_contacto =  "";
      // me.celular_contacto =  "";
      me.requerimientofecha_convocatoria =  "";
      // me.correo =  "";
      me.rubro_tipo_servicio =  "";
      // me.fecha_solicitud =  "";
      me.lista_detalles = [];
      me.nuevo = true;
      me.fecha_solicitud= new Date().toISOString().slice(0, 10);
      me.archivoReq = null;
      me.editando_fec_sol = false;
    },
    selectEmpleados() {
      let me = this;
      // console.log(me.empleados)
      var Array = [];
      axios
        .get("api/Empleados/SelectEmpleo")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empleados.push({ text: x.empleado, value: x.idempleado, id_areausuaria: x.id_areausuaria });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    getEmpleado() {
      let me = this;
      axios
        .get("api/Empleados/Mostrar/" + me.idoperador.toString())
        .then((response) => {
          me.empleado = response.data;
          // console.log("Empleado" + me.idoperador);
          if (me.empleado.areausuaria) {
            this.id_areausuaria=me.empleado.id_areausuaria
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    /* Requerimiento*/
    limpiarRequerimiento() {
      this.requerimientofecha_inicio = "";
      this.requerimientofecha_fin = "";
      this.idarea = "";
      this.requerimientofunciones = "";
      this.requerimiento_tipo = "";
      this.requerimiento_estado = "";
      this.requerimientocantidad = "";
      this.requerimiento_motivo = "";
      this.observaciones = "";
      this.requerimientoedadminima = "";
      this.requerimientoaño = new Year().getFullYear();
      this.editedIndexrequerimiento = -1;
    },

    selectRequerimiento() {
      let me = this;
      var Array = [];
      me.listarequerimientos = [];
      axios
        .get(`api/Requerimientos/Select/${this.idusuario}`)
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.listarequerimientos.push({
              text: x.denominacion,
              value: x.idrequerimiento,
            });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    onlyForCurrency($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    selectRequerimiento2() {
      let me = this;
      var Array = [];
      me.listarequerimientos = [];
      axios
        .get("api/Requerimientos/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.listarequerimientos2.push({
              text: x.denominacion,
              value: x.idrequerimiento,
            });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    listarRequerimiento() {
      let me = this;
      axios
        .get(`api/Requerimientos/Listar?idusuario=${me.idusuario}`)
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.requerimientos = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItem() {
      let emp = this.empleados;
      let me = this;
      var Array = [];
      this.loading = true;
      axios
        .get("api/Requerimientos/Mostrar/" + me.requerimientoid)
        .then(function (response) {
          me.requerimientoid = response.data.idrequerimiento;
          me.observaciones = response.data.observaciones;
          me.id_areausuaria = response.data.id_areausuaria;
          me.empleadosFiltrados = emp.filter(
            e => e.value === response.data.idoperador
          );
          me.$nextTick(() => {
            me.idoperador = response.data.idoperador;
          });
          me.codigo_contrato = response.data.codigo_contrato,
          me.empresa_contratista = response.data.empresa_contratista,
          me.id_contratista = response.data.id_empresa_contratista,
          me.tiempo_contratacion = response.data.tiempo_contratacion,
          me.elaborado_por = response.data.elaborado_por,
          me.cargo_area = response.data.cargo_area,
          me.empresa_contacto = response.data.empresa_contacto,
          me.celular_contacto = response.data.celular_contacto,
          me.requerimientofecha_convocatoria = response.data.fecha_inicio.split('T')[0],
          me.correo = response.data.correo,
          me.rubro_tipo_servicio = response.data.rubro_tipo_servicio,
          me.fecha_solicitud = response.data.fecha_solicitud.split('T')[0],
          me.tiempo_publicacion = response.data.tiempo_publicacion,
          me.editedIndexRequerimiento = 1;
          me.nuevo = false;
          me.listarDetalle();
          me.editedIndexDetalle = 1;
          me.filtros = false;
          me.editando_fec_sol = true;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
        axios
          .get(
            "api/Requerimientos/GetArchivoByRequerimiento/" +
            me.requerimientoid
          )
          .then(function (response) {
            if (response.data) {
              me.nombreArchivoReq = response.data.nombre_archivo;
            } else {
              me.nombreArchivoReq = null;
            }
          })
          .catch(function (error) {
            console.log(error);
            me.nombreArchivoReq = null;
          });
    },
    async verArchivo(idarchivo) {
        try {
            const response = await axios.get(
                `/api/Requerimientos/VerArchivo/${idarchivo}`,
                {
                    responseType: 'blob'
                }
            );
            const blob = new Blob([response.data], {
                type: response.headers['content-type']
            });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            // Liberar memoria después de un tiempo
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 10000);
        } catch (error) {
            console.error('Error al visualizar archivo:', error);
            alert('No se pudo abrir el archivo.');
        }
    },

    editItemRequerimiento(item) {
      this.requerimientoid = item.idrequerimiento;
      this.observaciones = item.observaciones;
      this.idoperador = item.idoperador,
      this.codigo_contrato = item.codigo_contrato,
      this.tiempo_contratacion = item.tiempo_contratacion,
      this.elaborado_por = item.elaborado_por,
      this.cargo_area = item.cargo_area,
      this.empresa_contacto = item.empresa_contacto,
      this.celular_contacto = item.celular_contacto,
      this.fecha_solicitud = item.fecha_solicitud,
      this.correo = item.correo,
      this.editedIndexRequerimiento = 1;
    },
    saveRequerimiento() {
      if (this.overlayr) return;
      this.validar1();
      if (this.form1HasErrors == false) {
        if (this.editedIndexRequerimiento > -1) {
          this.actualizarRequerimiento();
        } else {
          this.crearRequerimiento();
        }
      }
    },
    isDate(value) {
      switch (typeof value) {
        case "number":
          return true;
        case "string":
          return !isNaN(Date.parse(value));
        case "object":
          if (value instanceof Date) {
            return !isNaN(value.getTime());
          }
        default:
          return false;
      }
    },
    mostrarFecha(fecha) {
      var day = ("0" + fecha.getDate()).slice(-2);
      var month = ("0" + (fecha.getMonth() + 1)).slice(-2);
      var today = fecha.getFullYear() + "-" + month + "-" + day;
      return today;
    },
    crearRequerimiento() {
      const confirmar = confirm(
        "¿Está seguro(a) que desea crear el requerimiento? Una vez creado no se podrá eliminar."
      );

      if (!confirmar) {
        return;
      }

      this.overlayr = true;

      let me = this;
      axios
        .post("/api/Requerimientos/Crear", {
          denominacion: me.autodenominacion,
          observaciones: me.observaciones,
          idoperador: me.idoperador,
          codigo_contrato: me.codigo_contrato,
          tiempo_contratacion: Number(me.tiempo_contratacion),
          elaborado_por: me.elaborado_por,
          cargo_area: me.cargo_area,
          empresa_contacto: me.empresa_contacto,
          celular_contacto: me.celular_contacto,
          fecha_solicitud: me.fecha_solicitud,
          correo: me.correo,
          rubro_tipo_servicio: me.rubro_tipo_servicio,
          id_areausuaria: me.id_areausuaria,
          fecha_inicio: me.requerimientofecha_convocatoria,
          id_empresa_contratista: me.id_contratista,
          tiempo_publicacion: me.tiempo_publicacion,
          detalles: me.lista_detalles.map(x => ({
              ...x,
              cantidad: x.cantidad ? Number(x.cantidad) : null
          }))
        })
        .then(function (response) {
          me.requerimientoid = Number(response.data);
          console.log("Requerimiento creado " + me.requerimientoid);
          me.editedIndexrequerimiento = 1;
          me.color = "#2A3B4D";
          me.icon = "mdi-thumb-up";
          me.error = "Registro exitoso";
          me.snackbar = true;
          // me.saveProgramacion();
          me.selectRequerimiento();
          me.saveDetalle();
          if (this.archivoReq) {
            const formData = new FormData();
            formData.append(
                'idrequerimiento',
                idrequerimiento
            );
            formData.append(
                'archivo',
                this.archivoReq
            );
            axios.post(
                '/api/Requerimientos/AgregarArchivo',
                formData
            );
          }
          me.listar();
          me.nuevo = false;
          me.mensaje = "Registro exitoso";
          me.tipoMensaje = "success";
          setTimeout(() => {
            me.mensaje = "";
          }, 3000);
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
          me.mensaje = "Ocurrió un error al guardar";
          me.tipoMensaje = "error";
        })
        .finally(function () {
          me.overlayr = false;
        });
    },
    actualizarRequerimiento() {
      let me = this;
      axios
        .put("/api/Requerimientos/Actualizar", {
          idrequerimiento: me.requerimientoid,
          denominacion: me.autodenominacion,
          observaciones: me.observaciones,
          idoperador: me.idoperador,
          codigo_contrato: me.codigo_contrato,
          tiempo_contratacion: Number(me.tiempo_contratacion),
          elaborado_por: me.elaborado_por,
          cargo_area: me.cargo_area,
          empresa_contacto: me.empresa_contacto,
          celular_contacto: me.celular_contacto,
          fecha_solicitud: me.fecha_solicitud,
          correo: me.correo,
          rubro_tipo_servicio: me.rubro_tipo_servicio,
          id_areausuaria: me.id_areausuaria,
          fecha_inicio: me.requerimientofecha_convocatoria,
          id_empresa_contratista: me.id_contratista,
          tiempo_publicacion: me.tiempo_publicacion,
        })
        .then(function (response) {
          me.editedIndexrequerimiento = 1;
          me.color = "#2A3B4D";
          me.icon = "mdi-thumb-up";
          me.error = "Registro exitoso";
          me.snackbar = true;
          me.selectRequerimiento();
          me.saveDetalle();
          if (me.archivoReq) {
              const formData = new FormData();
              formData.append(
                  'idrequerimiento',
                  me.requerimientoid
              );
              formData.append(
                  'archivo',
                  me.archivoReq
              );
              axios.post(
                  '/api/Requerimientos/AgregarArchivo',
                  formData
              );
          }
          me.listar();
          // me.traerFechaInicioEvaluacion();
          me.nuevo = false;
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
        });
    },
    /*Experiencia*/
    // limpiarDetalle() {
    //   this.cantidad = "";
    //   this.servicio = "";
    //   this.detalle = "";
    //   this.editedIndexDetalle = -1;
    // },
    listarDetalle() {
      let me = this;
      me.lista_detalles = [];
      axios
        .get(
          "api/Detalles/GetDetallesByRequerimiento/?idrequerimiento=" +
            me.requerimientoid
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj['detalles']) {
            res.push(obj['detalles'][i]);
          }
          me.lista_detalles = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    remove4(item) {
      const index = this.tipos_servicio.findIndex(
        x => x === item.id   // porque item-value="id"
      );

      if (index !== -1) {
        this.tipos_servicio.splice(index, 1);
      }
    },
    async cargarAreasUsuaria() {
      try {
        const response = await axios.get("/api/AreaUsuaria/Listar");
        this.lista_areas = response.data;
      } catch (error) {
        console.error("Error cargando areas:", error);
      }
    },
    filtrarEmpleadosPorArea(areaId) {
      // console.log(this.empleados);
      this.empleadosFiltrados = this.empleados.filter(
        e => e.id_areausuaria === areaId
      );
      // console.log(this.empleadosFiltrados)
    },
    ListarPostulantes() {
      let me = this;
      me.cuallistar = "NORMAL";
      const payload = {};

      if (me.cobertura.includes(11))
        payload.cocinaplanta = me.cocinaplanta;

      if (me.cobertura.includes(10))
        payload.hospedaje = me.hospedaje;

      if (me.cobertura.includes(1)) {
        payload.garaje = me.garaje;
        payload.flota = me.flota;
      }

      if (me.cobertura.includes(2))
        payload.ubicacionequipo = me.ubicacionequipo;
        payload.maquinaria = me.maquinaria;

      if (me.cobertura.includes(8))
        payload.plantagrifo = me.plantagrifo;
      axios
        .post("api/FiltrosContratos/ListarContratos", {
          tipos_servicio: me.tipos_servicio.join(","),
          cobertura: me.cobertura.join(","),
          categorizacion_proveedor: me.categorizacion_proveedor.join(","),
          participacion_ccia: me.participacion_ccia.join(","),
          f_tipo_servicio: me.chktiposervicio,
          f_tipo_cobertura: me.chkcobertura,
          f_categorizacion: me.chkccategorizacion,
          f_ccia: me.chkcccia,
          f_empresas: me.chkempresas,
          // lista_empresas: me.empresasSeleccionadas.map(e => e.idempresa),
          lista_empresas: me.filtroEmpresas,
          f_carta: me.chkCarta,
          texto_carta: me.filtroCarta,
          ...payload
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          me.contratosempresas = [];
          var res = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.contratosempresas = res;
          if (me.contratosempresas.length > 0) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error =
              "Búsqueda exitosa. Se encontraron " +
              me.contratosempresas.length +
              " posibles empresas.";
            me.snackbar = true;
          } else {
            me.color = "#2A3B4D";
            me.icon = "mdi-information";
            me.error =
              "Búsqueda exitosa. Lamentablemente no se encontraron empresas, pruebe cambiando los filtros de busqueda por favor.";
            me.snackbar = true;
          }
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.snackbar = true;
        });
    },
    rowClicked(item) {
      const id = item.idempresa
      const index = this.selectedRows.indexOf(id)

      if (index === -1) {
        // agregar si no estaba seleccionado
        this.selectedRows.push(id)
      } else {
        // quitar si ya estaba seleccionado
        this.selectedRows.splice(index, 1)
      }
    },
    // Verifica si la fila está seleccionada
    isSelected(item) {
      return this.selectedRows.includes(item.idempresa)
    },
    async handleDownload() {

      if (!this.selectedRows.length) {
        alert('No hay contratos seleccionados')
        return
      }
      const contratosSeleccionados = this.contratosempresas.filter(c =>
        this.selectedRows.includes(c.idempresa)
      );
      // console.log(contratosSeleccionados);

      let payload = {
        empresa_contratista: this.empresa_contratista,
        ruc_contratista: this.ruc_contratista,
        elaborado_por: this.elaborado_por,
        celular_contacto: this.celular_contacto,
        correo: this.correo,
        fecha_solicitud: this.fecha_solicitud,
        lista_detalles: this.lista_detalles,
        selectedRows: contratosSeleccionados
      };

      this.downloadLoading = true
      console.log(this.selectedRows)
      try {
        const response = await axios.post(
          '/api/FiltrosContratos/ExportarSeguimiento',
          payload,
          { responseType: 'blob' } // importante para descargar binario
        )

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        console.log(this.rubro_tipo_s)
        const rubro = this.rubro_tipo_s.find(
          r => r.id === this.rubro_tipo_servicio
        );
        console.log(rubro)
        const nombre = rubro ? rubro.nombrecategoria : '';
        console.log(nombre)
        const nombreArchivo =
          `${this.zfill(this.requerimientoid, 3)}_RRQ_` +
          `${this.empresa_contratista}_` +
          `${nombre}_` +
          `${this.fechaActual()}.xlsx`;
        link.setAttribute('download', nombreArchivo)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

      } catch (error) {
        console.error('Error al exportar Excel', error)
      } finally {
        this.downloadLoading = false
      }
    },
    generarFechaInicio1() {
      if (this.isDate(this.requerimientofecha_convocatoria)) {
        var d = new Date(this.requerimientofecha_convocatoria + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.requerimientofecha_iniciolocales = this.mostrarFecha(d);
      }
    },
    generarFechaInicio2() {
      if (this.isDate(this.fecha_solicitud)) {
        var d = new Date(this.fecha_solicitud + "T00:00:00");
        d.setDate(d.getDate() + 1);
      }
    },
    customFilterCLocacion(item, queryText, itemText) {
      const textOne = item.clasificacion.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    abrirPopupCoberturas(valores) {
      if (!valores || valores.length === 0) {
          this.dialogFiltros = false
          return
        }

        this.dialogFiltros = true
    },
    guardarFiltros() {
      // Aquí envías todos los datos correspondientes a las coberturas seleccionadas
      const payload = {};
      if(this.cobertura.includes(11)) payload.cocinaplanta = this.cocinaplanta;
      if(this.cobertura.includes(10)) payload.hospedaje = this.hospedaje;
      if(this.cobertura.includes(1)) payload.garaje = this.garaje;
      if(this.cobertura.includes(2)) payload.ubicacionequipo = this.ubicacionequipo;
      if(this.cobertura.includes(8)) payload.plantagrifo = this.plantagrifo;
      if (this.cobertura.includes(2)) {payload.maquinaria = this.maquinaria};
      if (this.cobertura.includes(1)) {payload.flota = this.flota}

      console.log("Datos a guardar:", payload.garaje);
      this.dialogFiltros = false;
    },
    cargarEmpresasContratistas() {
      let me = this;
      me.lista_contratistas=[];
      axios
        .get("api/Contratistas/Listar")
        .then(function (response) {
          me.lista_contratistas = response.data;
          me.id_contratista = Number(localStorage.getItem('empresacontratista'))
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    onEmpresasChange() {
      this.filtroEmpresas = [...this.empresasSeleccionadas];

      console.log('Empresas seleccionadas:', this.filtroEmpresas);
    },
    quitarEmpresa(empresa) {
      this.empresasSeleccionadas = this.empresasSeleccionadas.filter(
        id => id !== empresa.idempresa
      );
      // const index = this.empresasSeleccionadas.findIndex(
      //   x => x === item.id   // porque item-value="id"
      // );

      // if (index !== -1) {
      //   this.empresasSeleccionadas.splice(index, 1);
      // }
    },
    zfill(num, size) {
      return String(num).padStart(size, '0');
    },
    fechaActual() {
      const f = new Date();
      const dd = String(f.getDate()).padStart(2, '0');
      const mm = String(f.getMonth() + 1).padStart(2, '0');
      const yyyy = f.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    },
    // selectEmpresa() {
    //   let me = this;
    //   me.empresasLis = [];
    //   let Array = [];
    //   axios
    //     .get("api/Empresas/Listar")
    //     .then(function (response) {
    //       Array = response.data;
    //       Array.map(function (x) {
    //         me.empresasLis.push({ text: x.razonsocial, value: x.idempresa });
    //       });
    //     })
    //     .catch(function (error) {
    //       //Porahora lo mostramos en consola
    //       console.log(error);
    //     });
    // },
  },
  watch: {
    id_areausuaria(newVal) {
      if (this.loading) return;
      // console.log("actualizo por watch")
      if (newVal) {
        this.filtrarEmpleadosPorArea(newVal);
      } else {
        this.empleadosFiltrados = [];
      }
    },
    cobertura(nuevo) {
      this.abrirPopupCoberturas(nuevo);
    },
    chkempresas(val) {
      if (!val) this.empresasSeleccionadas = [];
    }
  }
}
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
table,
th,
td {
  border: 1px solid #eceff1;
  border-collapse: collapse;
}
th,
td {
  padding: 5px;
  text-align: left;
}
</style>